 export const blockScroll = (initial: boolean) => {
  document.body.classList.toggle("is-modal-open", initial);
  document.querySelector("html")?.classList.toggle("is-modal-open", initial);
};